import { useContext } from 'react';

import type { PageContextValues } from '../../context/entity-page-context/entity-page-context';
import { PageContext } from '../../context/entity-page-context/entity-page-context';

export const usePageContext = (): PageContextValues => {
  const context = useContext(PageContext);

  if (!context || !context.pageContext) {
    throw new Error('No host context found. Please setup the PageContext');
  }

  return context;
};
